import React from "react";

const PageHeader = ({ text }) => {
  return (
    <div className="border-left-3 border-primary w-full bg-primary-50 p-2">
      <b className="m-0 p-0 text-xl">{text}</b>
    </div>
  );
};

export default PageHeader;
